
//not sure how to implement in Nuxt3
/* import axios from '../services/axios_auth'
export default (context) => {
  axios.setContext(context)
} */
// TODO check if this is still needed
// eslint-disable-next-line no-unused-vars
export default defineNuxtPlugin(nuxtApp => {})
